import { c as _c } from "react/compiler-runtime";
import { SubscriptionExpirationBanner } from "@components/banners/subscription-expiration-banner";
import { TrialExpirationBanner } from "@components/banners/trial-expiration-banner";
import { WorkspaceSpecificBanner } from "@components/banners/workspace-specific-banner/workspace-specific-banner";
import { WORKSPACE_SPECIFIC_BANNERS } from "@components/banners/workspace-specific-banner/workspace-specific-banner-constants";
import { ResendVerification } from "@components/resend-verification";
import { ExceededSubscriptionLimitsBanner } from "@pages/settings/subscription-settings/exceeded-subscription-limits-banner";

/** List of all the banners to show to customer in the header */
export function BannersHeaderLayout() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <>{WORKSPACE_SPECIFIC_BANNERS.map(_temp)}<ResendVerification /><TrialExpirationBanner /><SubscriptionExpirationBanner /><ExceededSubscriptionLimitsBanner /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(banner, index) {
  return <WorkspaceSpecificBanner key={index} {...banner} />;
}